import { render, staticRenderFns } from "./icon-error.vue?vue&type=template&id=21199246&"
import script from "./icon-error.vue?vue&type=script&lang=js&"
export * from "./icon-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21199246')) {
      api.createRecord('21199246', component.options)
    } else {
      api.reload('21199246', component.options)
    }
    module.hot.accept("./icon-error.vue?vue&type=template&id=21199246&", function () {
      api.rerender('21199246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/result/src/icon-error.vue"
export default component.exports